/**
 * Search form scripts
 */

import delegate from 'delegate';

import * as tools from '@utils/tools';

const el = {
	container: document.querySelector('[data-js="site-wrap"]'),
	searchForm: document.querySelectorAll('[data-js="search-form"]'),
};

/**
 * Update the form parameters & labels to reflect the selected search option.
 *
 * @param e
 */
const updateSearchFormValues = (e) => {
	const selOption = e.delegateTarget;
	const form = tools.closest(selOption, '[data-js="search-form"]');
	const label = form.querySelector('[data-js="search-label"]');
	const query = form.querySelector('[data-js="search-query"]');

	form.action = selOption.dataset.action;
	label.innerHTML = selOption.dataset.label;
	query.name = selOption.value;
	query.placeholder = selOption.dataset.label;
};

/**
 * Validate that the search term isn't empty and focus on the term input instead of submitting the form if it is empty.
 *
 * @param e
 */
const validateSearch = (e) => {
	const form = e.delegateTarget;
	const query = form.querySelector('[data-js="search-query"]');

	if (!query.value) {
		query.focus();
		e.preventDefault();
	}
};

/**
 * Bind any even handlers this module utilizes.
 */
const bindEvents = () => {
	delegate(el.container, '[data-js="search-option"]', 'change', updateSearchFormValues);
	delegate(el.container, '[data-js="search-form"]', 'submit', validateSearch);
};

/**
 * Init this module.
 */
const init = () => {
	if (!el.searchForm.length) {
		return;
	}

	bindEvents();
};

export default init;
